module.exports = __webpack_public_path__ + "static/media/edit.79145c33.svg";